import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    bellNotifications: [], 
};

const bellNotificationsSlice = createSlice({
    name: 'bellNotifications',
    initialState,
    reducers: {
        setBellNotifications: (state, action) => {
            state.bellNotifications = action.payload;
        },

    },
});

export const { setBellNotifications } = bellNotificationsSlice.actions;
export default bellNotificationsSlice.reducer;
